import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Member extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Member'
  // Define default properties here
  static instanceDefaults() {
    return {
      first_name: "",
      last_name: "",
      cell: "",
      email: "",
      id_number: "",
      passport_number: "",
      physical_address: "",
      postal_address: "",
      status:"",
      contact: {},
      location: {},
      custom: {},
      properties: {},
      allowed_tg_groups: [],
      whitelisted_groups: [],
      // joins
      groups: [],
      member_groups: [],
      files: []
    }
  }

  static setupInstance(data, { models }) {
    if (data.groups) {
      /* eslint-disable */
      data.groups.forEach(group => {
        group = new models.bot.Group(group)
      });
      /* eslint-enable */
    }

    if (data.member_groups) {
      /* eslint-disable */
      data.member_groups.forEach(mg => {
        mg = new models.bot.GroupMembers(mg)
      });
      /* eslint-enable */
    }
    return data
  }
}

const servicePath = 'members'
const servicePlugin = makeServicePlugin({
  Model: Member,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin